import React, { useRef, useEffect } from 'react';

interface GanttTask {
  id: string;
  name: string;
  start: string;
  end: string;
  progress: number;
  dependencies?: string;
  custom_class?: string;
}

interface GanttChartProps {
  tasks: GanttTask[];
  viewMode: 'Day' | 'Week' | 'Month';
  onDateChange?: (id: string, start: string, end: string) => void;
  onProgressChange?: (id: string, progress: number) => void;
}

const GanttChart: React.FC<GanttChartProps> = ({ tasks, viewMode, onDateChange, onProgressChange }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const ganttRef = useRef<any>(null);

  useEffect(() => {
    // frappe-gantt の CSS を動的に読み込み
    const linkId = 'frappe-gantt-css';
    if (!document.getElementById(linkId)) {
      const link = document.createElement('link');
      link.id = linkId;
      link.rel = 'stylesheet';
      link.href = 'https://cdn.jsdelivr.net/npm/frappe-gantt@0.6.1/dist/frappe-gantt.min.css';
      document.head.appendChild(link);
    }
  }, []);

  useEffect(() => {
    if (!containerRef.current || tasks.length === 0) return;

    const initGantt = async () => {
      try {
        // @ts-ignore
        const Gantt = (await import('frappe-gantt')).default;

        if (ganttRef.current) {
          ganttRef.current.refresh(tasks);
          return;
        }

        ganttRef.current = new Gantt(containerRef.current!, tasks, {
          view_mode: viewMode,
          date_format: 'YYYY-MM-DD',
          on_date_change: (task: any, start: Date, end: Date) => {
            const fmt = (d: Date) => {
              const y = d.getFullYear();
              const m = String(d.getMonth() + 1).padStart(2, '0');
              const day = String(d.getDate()).padStart(2, '0');
              return `${y}-${m}-${day}`;
            };
            onDateChange?.(task.id, fmt(start), fmt(end));
          },
          on_progress_change: (task: any, progress: number) => {
            onProgressChange?.(task.id, progress);
          },
          on_click: (task: any) => {
            // クリック時の処理（必要に応じて）
          },
        });
      } catch (err) {
        console.error('Gantt initialization failed:', err);
      }
    };

    initGantt();

    return () => {
      // cleanup
    };
  }, [tasks, viewMode, onDateChange, onProgressChange]);

  useEffect(() => {
    if (ganttRef.current) {
      ganttRef.current.change_view_mode(viewMode);
    }
  }, [viewMode]);

  return (
    <div
      ref={containerRef}
      style={{
        width: '100%',
        minHeight: '300px',
        overflowX: 'auto',
      }}
    >
      {tasks.length === 0 && (
        <div style={{ textAlign: 'center', padding: '40px', color: '#9ca3af' }}>
          工程データがありません
        </div>
      )}
    </div>
  );
};

export default GanttChart;
